<template lang="html">
  <div id="advantages-page" data-aos="fade">

    <section class="main-section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-title">
            <h1 class="title-s1">Nuestras ventajas</h1>

            <h5 class="subtitle">Tenemos valores añadidos, que se traducen en ventajas para nuestros clientes.</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-advantages">
            <div class="row content">
              <div class="col-md-8 col-lg-3 col-advantage" data-aos="fade-up">
                <div class="b-icon">
                  <img src="public/images/pages/advantages/icon-1.svg">
                </div>

                <h5 class="text">Calidad en nuestros procesos y productos</h5>
              </div>

              <div class="col-md-8 col-lg-3 col-advantage" data-aos="fade-up" data-aos-delay="150">
                <div class="b-icon">
                  <img src="public/images/pages/advantages/icon-2.svg">
                </div>

                <h5 class="text">Precios competitivos</h5>
              </div>

              <div class="col-md-8 col-lg-3 col-advantage" data-aos="fade-up" data-aos-delay="300">
                <div class="b-icon">
                  <img src="public/images/pages/advantages/icon-3.svg">
                </div>

                <h5 class="text">Tiempo de entrega y servicio acorde a sus necesidades</h5>
              </div>

              <div class="col-md-8 col-lg-3 col-advantage" data-aos="fade-up" data-aos-delay="450">
                <div class="b-icon">
                  <img src="public/images/pages/advantages/icon-4.svg">
                </div>

                <h5 class="text">Desarrollo de productos y proyectos a la medida de el cliente</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="companies-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-companies">
            <h2 class="title-s1" data-aos="fade-up" data-aos-delay="150">Desarrollo de colores</h2>
            <p class="text" data-aos="fade-up" data-aos-delay="300">
              Se cuenta con un catálogo de colores institucionales ya desarrollados, estos colores son generalmente utilizados para publicidad por empresas.
            </p>

            <div class="box-carousel" data-aos="fade-up" data-aos-delay="450">
              <swiper class="swiper" :options="swiperOption">
                <swiper-slide>
                  <div class="box-logo">
                    <div class="inside">
                      <img src="public/images/pages/advantages/logo-1.jpg">
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="box-logo">
                    <div class="inside">
                      <img src="public/images/pages/advantages/logo-2.jpg">
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="box-logo">
                    <div class="inside">
                      <img src="public/images/pages/advantages/logo-3.jpg">
                    </div>
                  </div>
                </swiper-slide>

                <swiper-slide>
                  <div class="box-logo">
                    <div class="inside">
                      <img src="public/images/pages/advantages/logo-4.jpg">
                    </div>
                  </div>
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container extra-info-section">
      <div class="row">
        <div class="col-lg-6 col-content" data-aos="fade-up" data-aos-delay="150">
          <div class="col box-title">
            <h5 class="txt-lg">Se cuenta con una serie de rodillos de grabado como son:</h5>
          </div>

          <div class="col align-self-center box-checks">

            <p class="p-check"><span class="box"><i class="fas fa-check"></i> <span class="txt">Brillo</span></span></p>
            <p class="p-check"><span class="box"><i class="fas fa-check"></i> <span class="txt">Mate</span></span></p>
            <p class="p-check"><span class="box"><i class="fas fa-check"></i> <span class="txt">Haircell</span></span></p>
            <p class="p-check"><span class="box"><i class="fas fa-check"></i> <span class="txt">Rayas diagonales</span></span></p>
          </div>
        </div>

        <div class="col-lg-6 col-content" data-aos="fade-up" data-aos-delay="300">
          <div class="col box-title">
            <h5>Los cuales se puede utilizar de acuerdo a los requerimientos en materiales varios combinando también con las diferentes opacidades:</h5>
          </div>

          <div class="col align-self-center box-checks">
            <p class="p-check"><span class="box"><i class="fas fa-check"></i> <span class="txt">Traslúcida</span></span></p>
            <p class="p-check"><span class="box"><i class="fas fa-check"></i> <span class="txt">Opaco</span></span></p>
            <p class="p-check"><span class="box"><i class="fas fa-check"></i> <span class="txt">Media opacidad</span></span></p>
            <p class="p-check"><span class="box"><i class="fas fa-check"></i> <span class="txt">Alta opacidad</span></span></p>
          </div>
        </div>

        <div class="col-12 col-extra" data-aos="fade-up" data-aos-delay="150">
          <p>
            El desarrollo de algún color que no exista en nuestro catálogo es posible, en un plazo de 20 dias. Los tiempos de entrega varian , desde la entrega inmediata hasta 20 dias en desarrollos especificos.
          </p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      // == Carousels options ==
      swiperOption: {
        loop: true,
        speed: 700,
        slidesPerView: 3,
        spaceBetween: 30,

        autoplay: {
          delay: 4500,
          disableOnInteraction: false
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 30
          },
        }
      }
      // == ==
    }
  }
}
</script>
